import React,{Component} from 'react';
import {Link,browserHistory} from 'react-router';
import $ from 'jquery';
import ReactStars from 'react-stars';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';
import { Modal } from 'react-bootstrap';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class Web_GiveRatings extends Component{
	constructor(props){
		super(props);
		this.state={
			seed_rate:0,
			over_rate:0,
			serv_rate:0,
			pack_rate:0,
			recomend:true,
			seller:localStorage.getItem('seller'),
			book_date:localStorage.getItem('book_date'),
			nodata_status:false,
			successRating:false,
		}
		// this.getSeedDetails=this.getSeedDetails.bind(this);
		// this.getProductDetails=this.getProductDetails.bind(this);
		this.over_rateChanged=this.over_rateChanged.bind(this);
		this.seed_rateChanged=this.seed_rateChanged.bind(this);
		this.serv_rateChanged=this.serv_rateChanged.bind(this);
		this.pack_rateChanged=this.pack_rateChanged.bind(this);
		this.handleChange=this.handleChange.bind(this);
		this.getRatingDetails=this.getRatingDetails.bind(this);
		this.close=this.close.bind(this);
	}
	componentDidMount()
	{
		if(!localStorage.token && !localStorage.user_id)
		{
			if(this.props.params.Product==='product')
			{
				localStorage.setItem('give_rating','/web/giverating/'+this.props.params.Product+'/'+this.props.params.Bid);
				browserHistory.push('/web/login');
			}
			else
			{
				localStorage.setItem('give_rating','/web/giverating/'+this.props.params.Bid);
				browserHistory.push('/web/login');
			}
		}
		else
		{
			this.getRatingDetails();
		}
		if(screen.width < 800)
		{
			if(this.props.params.Product==='product')
			{
				window.location.href="/giverating/"+this.props.params.Product+'/'+this.props.params.Bid;	
			}
			else
			{
				window.location.href="/giverating/"+this.props.params.Bid;
			}
		}
	}
	close()
	{
		this.setState({
			successRating:false,
		});
	}
	getRatingDetails()
	{
		if(this.props.params.Product==='product')
		{
			var type=1;
		}
		else
		{
			type=0;
		}
		var data1={from:'desktop_web',uid:localStorage.user_id,token:localStorage.token,type:type,bid:this.props.params.Bid};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'pre_rate_info',
			success:function(data)
			{
				if(data.status==='success')
				{
					this.setState({
						seller:data.seller_name,
						book_date:data.created_on,
					});	
				}
				else
				{
					this.setState({
						nodata_status:true,
					});
				}
			}.bind(this),
			error:function(err)
			{

			}
		});	
	}
	over_rateChanged(newRating)
	{
		// console.log(newRating);
		this.setState({
			over_rate:newRating,
		});
	}
	seed_rateChanged(newRating)
	{
		// console.log(newRating);
		this.setState({
			seed_rate:newRating,
		});
	}
	serv_rateChanged(newRating)
	{
		// console.log(newRating);
		this.setState({
			serv_rate:newRating,
		});
	}
	pack_rateChanged(newRating)
	{
		// console.log(newRating);
		this.setState({
			pack_rate:newRating,
		});
	}
	handleChange()
	{
		this.setState({
			recomend: !this.state.recomend,
		});
	}
	submitRatings()
	{
		// saveRatings(id,token,vid,deal_id,ser_qlty,seed_qlty,pack_qlty,book_id,overall,recomend)
		
		if(localStorage.vid)
		{
			var vid=localStorage.getItem('vid');
		}
		else
		{
			vid='';
		}
		if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
		
		if(localStorage.user_id)
	    {
	    	var uid=localStorage.user_id;
	    }
	    else
	    {
	    	uid=0;
	    }
		if(this.props.params.Product==='product')
		{
			var data1={from:'desktop_web',id:uid,token:localStorage.token,book_id:this.props.params.Bid,product_id:localStorage.product_id,ser_qlty:this.state.serv_rate,product_qlt:this.state.seed_rate,pack_qlty:this.state.pack_rate,overall:this.state.over_rate,recomend:this.state.recomend,source:source,campaign:campaign,url_id:url_id};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				data:{req:data2},
				url:baseUrl+'savepro_ratings',
				success:function(data)
				{
					if(data.status==='ok')
					{
						this.setState({
							successRating:true,
						});
						// alert("Thanks for Rating");
						browserHistory.push('/web/myorders')
					}
				}.bind(this),
				error:function(err)
				{
					// console.log(err);
				}
			});
		}
		else
		{
			data1={from:'desktop_web',id:uid,token:localStorage.token,vid:vid,deal_id:'',ser_qlty:this.state.serv_rate,seed_qlty:this.state.seed_rate,pack_qlty:this.state.pack_rate,book_id:this.props.params.Bid,overall:this.state.over_rate,recomend:this.state.recomend,source:source,campaign:campaign,url_id:url_id};
			data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				data:{req:data2},
				url:baseUrl+'saveRatings',
				success:function(data)
				{
					if(data.status==='ok')
					{
						this.setState({
							successRating:true,
						});
						// alert("Thanks for Rating");
						browserHistory.push('/web/myorders')
					}
				}.bind(this),
				error:function(err)
				{
				}
			});
		}
	}
	render(){
		document.title=this.props.params.Product ==='product' ? 'Give Product Ratings | AquaDeals' : 'Give Hatchery Ratings | AquaDeals';
		$('body').css('background','#f1f1f2');
		// $(window).scrollTop(0);
		var over_rate=<ReactStars
						  className={'rate_dtls_item'}
						  count={5}
						  onChange={this.over_rateChanged}
						  size={20}
						  value={this.state.over_rate}
						  // color1={'#F3F3F3'}
						  color2={'#ffc50a'} />
		var serv_rate=<ReactStars
						  className={'rate_dtls_item'}
						  count={5}
						  onChange={this.serv_rateChanged}
						  size={20}
						  value={this.state.serv_rate}
						  // color1={'#F3F3F3'}
						  color2={'#ffc50a'} />;
		var seed_rate=<ReactStars
						  className={'rate_dtls_item'}
						  count={5}
						  onChange={this.seed_rateChanged}
						  size={20}
						  value={this.state.seed_rate}
						  // color1={'#F3F3F3'}
						  color2={'#ffc50a'} />;
		var pack_rate =<ReactStars
		 				  className={'rate_dtls_item'}
						  count={5}
						  onChange={this.pack_rateChanged}
						  size={20}
						  value={this.state.pack_rate}
						  // color1={'#F3F3F3'}
						  color2={'#ffc50a'} />;

		
		var switch_btn =<div className="webswitch-container custom_switch_blk">
			                <label>
			                    <input ref="switch" checked={this.state.recomend} onChange={this.handleChange} className={this.state.recomend ? "webswitch active":"webswitch"} type="checkbox" />
			                    <div>
			                        <span><g className="icon icon-toolbar grid-view"></g></span>
			                        <span><g className="icon icon-toolbar ticket-view"></g></span>
			                        <div></div>
			                    </div>
			                </label>
			            </div>;
		return(
			<div className="web_Deals web_giverating_page">
				<WebHeaderInner />
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<section className="container web_givRat_container">
					<div className="row">
						<div className="col-md-12 webDels_cntnt">
							{this.state.nodata_status ? 
								<section>
									<div className="web_unauth_blk"><h4>You are not authorized !</h4><a href="/web/login" className="web_link_btn">Sign in Here</a></div>
								</section> : 
								<section className="web_give_rate_blk" >
									<div className="container-fluid row">
										{/*<h5><Link onClick={()=>{browserHistory.goBack()}}><i style={{marginRight:'15px'}}><img src={baseAssets+'icons/web_icons/close_icon1.png'} width="16px" alt=""/></i></Link>{this.props.params.Product ==='product' ? 'Give Product Ratings' : 'Give Hatchery Ratings'}</h5>
										<a href="/web/home" title="Home" className="web_home_icon"><img src={baseAssets+'icons/web_icons/home2.png'} alt="Home" /></a>*/}
								    <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4">
										<img src={baseAssets+'images/promo_offers/20170310100146779139.png'} alt="" />
									</div>
									<div className="col-xs-8 col-sm-8 col-md-8 col-lg-8">
										<h4 className="web_giverate_title">{this.props.params.Product ==='product' ? 'Give Product Ratings' : 'Give Hatchery Ratings'}</h4>
										<div className="from_dtls_blk">
											<p className="giverate_frm">FROM</p>
											{this.state.seller ? <p>{this.state.seller}</p> : <p>&nbsp;</p>}
											<p>ORDER DATE</p>
											{this.state.book_date ? <p>{this.state.book_date}</p> : <p>&nbsp;</p>}
										</div>
									
									<div style={{marginTop:'10px',fontSize:'12px'}}>
										<div className="rating_list_blk">
											<div className="rating_list_item">
												<span style={{float:'left'}}>Overall Rating</span>
												{over_rate}
											</div>
											<div className="rating_list_item">
												<span style={{float:'left'}}>Service Quality</span>
												{serv_rate}
											</div>
											<div className="rating_list_item">
												<span style={{float:'left'}}>{this.props.params.Product==='product' ? 'Product Quality' :  'Seed Quality' }</span>
												{seed_rate}
											</div>
											<div className="rating_list_item">
												<span style={{float:'left'}}>Packing Quality</span>
												{pack_rate}
											</div>
										</div>
									</div>
									<section style={{marginTop:'10px',}}>
										{this.state.recomend === true ? <div className="rate_rec_blk"><span style={{width:'75%',display:'block'}}>{this.props.params.Product ==='product' ? 'I recommended this product to other customers' : 'I recommended this hatchery to other customers'}</span><span>{switch_btn}</span></div> : <div className="rate_rec_blk"><span style={{width:'75%',display:'block'}}>{this.props.params.Product ==='product' ? 'I recommended this product to other customers' : 'I recommended this hatchery to other customers'}</span><span>{switch_btn}</span></div>}
									</section>
									<div className="text-right">
										<button className="save_rating_btn" onClick={()=>{this.submitRatings()}}>SUBMIT</button>
									</div>
								  </div>
							   </div>	
						    </section>

							}
							<Modal className="showModal" show={this.state.successRating} onHide={this.close}  >
								<Modal.Body>
					          		<h4 style={{fontSize:'14px', color:'#666',textAlign:'center'}}>Thanks for Rating</h4>
					        	</Modal.Body>
					        </Modal>
						</div>
					</div>
				</section>
				<WebFooter />
			</div>
			
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Accounts/Web_GiveRatings.js
 **/